import { render, staticRenderFns } from "./CentroCustoSelect.vue?vue&type=template&id=2b39676a&scoped=true"
import script from "./CentroCustoSelect.vue?vue&type=script&lang=js"
export * from "./CentroCustoSelect.vue?vue&type=script&lang=js"
import style0 from "./CentroCustoSelect.vue?vue&type=style&index=0&id=2b39676a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b39676a",
  null
  
)

export default component.exports